import React from "react";

// Scan the current directory for all .js files
const requireContext = require.context("./", false, /\.(js)$/);

export const icons = requireContext.keys().reduce((acc, filePath) => {
    // Skip BaseIcon itself
    if (filePath === "./BaseIcon.js") return acc;

    const componentName = filePath.replace(
        /^\.\/(.*)\.js$/,
        "$1"
    );

    const key =
        componentName.charAt(0).toLowerCase() +
        componentName.slice(1);

    acc[key] = requireContext(filePath).default;

    return acc;
}, {});


const BaseIcon = ({ name, fallback = null, ...props }) => {

    // Nothing passed
    if (!name) { return fallback; }

    // If name is already a React element
    if (React.isValidElement(name)) { return name; }

    // If name is not a string
    if (typeof name !== "string") { return fallback; }

    // Try to find centralized icon
    const IconComponent = icons[name];

    // Found centralized icon
    if (IconComponent) { return <IconComponent {...props} />; }

    // Not found:
    // return the original string/emoji
    return fallback !== null ? fallback : name;
};

export default BaseIcon;
